/**
 * @ngdoc Application Directives
 * @name TabbedView Directive
 *
 * @description
 * Directive that adds UI-Views dynamically base on open tabs
 * This is a requirment enforce by UI-Router sticky state
 */
(function () {
    'use strict';

    angular.module('aeroLineCrew').directive('tabbedView', [
        'ApplicationService',
        'EventManagerService',
        function (ApplicationService,EventManagerService) {
            return {
                restrict : 'AE',
                template : '<div class="tabbed-view-container">' +
                '<div data-ng-repeat="viewObj in viewsDataSource track by $index" data-ui-view="{{viewObj.view}}" ng-show="viewObj.state == selectedTab"></div>' +
                '</div>',
                scope : {
                    viewsDataSource : '=',
                    selectedTab : '='
                },
                link:function(element,scope,attr){
                    console.log(scope.items);
                }
            };
        }]);
})();